const useMaterialBank = () => {
    const addToCart = (values: { itemNumber: string, brands:string[] }) => {        
        async function mbAddToCart(sku: string, metadata: string[]){
            const { isOk, data } = await window["cart-widget"]._MBWidgetCart(sku, metadata);
            if (!isOk) {
                window['cart-widget']._MBWidgetDisplayErrorModal(data);

                const errorModal = document.getElementById("mbw-error-modal");
                const backdrop = errorModal?.querySelector('[aria-hidden="true"]');


                backdrop!.addEventListener('click', () => {
                    document.body.style.overflow = "visible";
                });

                document.addEventListener('click', (event) => {
                    if (event.target != null && event.target !== errorModal && !errorModal?.contains(event.target as HTMLElement)) {
                        document.body.style.overflow = "visible";
                    }
                });

                document.body.style.overflow = "unset";
            }
            return { isOk, data };
        }
        

        if(window["cart-widget"] === undefined) {
            return;
        }

        const items = [];
        if(values['itemNumber'] !== undefined){
            items.push(mbAddToCart(values.itemNumber, values.brands));
        }
        
        
        

        return items;
    }


    return { addToCart }
}


export default useMaterialBank;